import { formatTicker } from '@api/mappers/formatTicker';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { EllipsisDetector } from '@terminal/components/ellipsis-detector/EllipsisDetector';
import { useEntity } from '@terminal/react-query-hooks/entities/useEntities';
import clsx from 'clsx';
import { PulseCompanyRef } from '../../pulse-types';
import styles from './PulseCompanyCell.module.scss';

export interface PulseCompanyCellProps {
  company: PulseCompanyRef;
  layout?: 'stacked' | 'inline';
}

export const PulseCompanyCell = ({
  company,
  layout = 'stacked',
}: PulseCompanyCellProps) => {
  const { data } = useEntity(company.entityTag);
  const entity = data?.data;

  const name = entity?.name_short || entity?.name || company.name;
  const ticker = entity ? formatTicker(entity) : company.ticker;

  return (
    <div className={styles.root} data-testid="pulse-company-cell">
      {entity && (
        <AssetLogoContainer
          entity={entity}
          size={layout === 'inline' ? 20 : 28}
        />
      )}
      <div
        className={clsx(styles.labels, {
          [styles.inline]: layout === 'inline',
        })}
      >
        {name && (
          <EllipsisDetector inPortal label={name}>
            <span className={styles.name}>{name}</span>
          </EllipsisDetector>
        )}
        {layout === 'inline' && <span className={styles.separator}>·</span>}
        <span className={styles.ticker}>{ticker}</span>
      </div>
    </div>
  );
};
